import React from 'react'
import { Typography } from '@telavita-core/react-design-kit'
import { ReactComponent as AlertIcon } from 'static/svg/alert-icon.svg'

import * as S from './styles'

export const ScheduleInSameWeekFeedbackError = (): JSX.Element => {
  return (
    <S.Container>
      <AlertIcon />
      <Typography
        variant='content2'
        color='danger'
      >
        Não é possível agendar na data acima pois você já possui uma consulta na semana correspondente. <b>Selecione outro dia.</b>
      </Typography>
    </S.Container>
  )
}